module.exports = __webpack_public_path__ + "img/weddings_12_V.34135e0f.webp";